import type { AxiosPromise, AxiosRequestConfig } from "axios";

import Api from "api/Api";
import type { ApiResponse } from "api/ApiResponses";
import type { AnnouncementItem } from "ce/pages/Applications/Home";

export type FetchCurrentTenantConfigResponse = ApiResponse<{
  userPermissions: string[];
  tenantConfiguration: Record<string, string>;
  new: boolean;
}>;

export type UpdateTenantConfigResponse = ApiResponse<{
  tenantConfiguration: Record<string, string>;
}>;

export interface UpdateTenantConfigRequest {
  tenantConfiguration: Record<string, string>;
  needsRefresh?: boolean;
  isOnlyTenantSettings?: boolean;
  apiConfig?: AxiosRequestConfig;
}

export interface UpdateAonmuecementsTenantConfigRequest {
  announcements: AnnouncementItem[];
}

export class TenantApi extends Api {
  static tenantsUrl = "v1/tenants";

  static async fetchCurrentTenantConfig(): Promise<
    AxiosPromise<FetchCurrentTenantConfigResponse>
  > {
    return Api.get(`${TenantApi.tenantsUrl}/current`);
  }

  static async updateTenantConfig(
    request: UpdateTenantConfigRequest,
  ): Promise<AxiosPromise<UpdateTenantConfigResponse>> {
    return Api.put(
      `${TenantApi.tenantsUrl}`,
      request.tenantConfiguration,
      null,
      {
        ...(request.apiConfig || {}),
      },
    );
  }

  static async updateAonmuecementsTenantConfig(
    request: UpdateAonmuecementsTenantConfigRequest,
  ): Promise<AxiosPromise<UpdateTenantConfigResponse>> {
    return Api.put(TenantApi.tenantsUrl + "/announcements", request);
  }
}

export default TenantApi;
